module.exports = __webpack_public_path__ + "img/icfa-image-generale.094eac0.jpg";